import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { AuthProvider } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import Programs from "@/pages/Programs";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import PlayersDirectory from "@/pages/PlayersDirectory";
import PlayerPublic from "@/pages/PlayerPublic";
import Coaches from "@/pages/Coaches";
import Recruiting from "@/pages/Recruiting";
import Events from "@/pages/Events";
import Pricing from "@/pages/Pricing";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";
import PaymentResult from "@/pages/PaymentResult";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-right" richColors />
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/programs" element={<Programs />} />
              <Route path="/players" element={<PlayersDirectory />} />
              <Route path="/coaches-portal" element={<PlayersDirectory />} />
              <Route path="/players/:id" element={<PlayerPublic />} />
              <Route path="/coaches" element={<Coaches />} />
              <Route path="/recruiting" element={<Recruiting />} />
              <Route path="/events" element={<Events />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
              <Route path="/admin" element={<ProtectedRoute roles={["admin"]}><Admin /></ProtectedRoute>} />
              <Route path="/payment/success" element={<PaymentResult status="success" />} />
              <Route path="/payment/cancel" element={<PaymentResult status="cancel" />} />
            </Routes>
          </Layout>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
